/** Whole minutes from 1 to 60, as ActivTrak takes them. The table's CHECK, the
 * setter function and the admin route all enforce the same range. */
export const IDLE_THRESHOLD_MIN_SECONDS = 60;
export const IDLE_THRESHOLD_MAX_SECONDS = 3600;
//# sourceMappingURL=agent-idle-thresholds.js.map